import {Flow, FlowFetchResponse} from '../_services/Flow';

export const getReportMetricDetails = (metric: string, dashboardConfiguration: any, workflowId: any, setDetailDataIsLoading: any, setDetailData: any) => {
    setDetailDataIsLoading(true);

    let title = '';
    if (metric === 'open') {
        title = 'Open Workflows';
    } else if (metric === 'completed') {
        title = 'Completed Workflows';
    } else if (metric === 'average_duration') {
        title = 'Workflows used to calculate Average Duration';
    } else if (metric === 'started') {
        title = 'Started Workflows';
    }

    Flow.getInstance().getReportMetricDetail(workflowId, metric,{
        page: 1,
        page_size: 1000,
        workflow: workflowId,
        fieldFilters: dashboardConfiguration.fieldFilters,
    })
        .then((response: FlowFetchResponse) => {
            if (response.ok) {
                setDetailData({
                    title,
                    metric,
                    data: {
                        ...response.json,
                        columns: [
                            {prop: 'lineNumber', label: '#'},
                            ...response.json.columns
                        ],
                        entries: response.json.entries.map((entry: any, index: number) => ({
                            'lineNumber': index + 1,
                            ...entry
                        }))
                    },
                });
            } else {
                throw Error(response?.json?.message || 'Error getting detail');
            }
        })
        .catch((error: any) => {
            console.log(error);
            // setErrorMessage(error?.message || error || 'Error getting detail');
        })
        .finally(() => {
            setDetailDataIsLoading(false);
        });
}